import { convertRowsToCamelCaseArray, toCamelCase, getCachedEurUsdRateSync } from "@revbox/helpers-fe";
import { inventoryStatsTableHeaders } from "@revbox/localization";

function getTableHeaders(column, language) {
  return (
    inventoryStatsTableHeaders[language]?.[column] || column
  );
}

// Normalize column name the same way as backend does
// This converts "Average CPC" -> "average_cpc", "ID" -> "id", etc.
function normalizeColumnName(str) {
  return (str || '').toLowerCase().replace(/\s+/g, '_');
}

export function getServerSideDatasourceInvStats(
  getData,
  hiddenColumns,
  colWidth,
  setColumns,
  search,
  currentPeriod,
  previousPeriod,
  campaignId,
  token,
  view,
  language,
  sortingParams
) {
  // Store mapping between camelCase fields and original column names
  let fieldToColumnMap = {};
  
  return {
    getRows: async (params) => {
      const currentPage = params.api.paginationGetCurrentPage() + 1;
      
      // Get sorting from AG-Grid if sortingParams is a function (getter)
      const currentSortingParams = typeof sortingParams === 'function' 
        ? sortingParams() 
        : sortingParams;
      
      console.log('📦 [LOCAL] getRows called, sortingParams:', currentSortingParams);
      
      // Get the original column name from mapping or AG-Grid
      let backendSortingParams = null;
      if (currentSortingParams?.columnName) {
        let originalColumnName = fieldToColumnMap[currentSortingParams.columnName];
        
        // If not in mapping, try to get from AG-Grid column metadata
        if (!originalColumnName) {
          const columnDefs = params.api.getColumnDefs();
          const column = columnDefs?.find(col => col.field === currentSortingParams.columnName);
          if (column?.originalColumnName) {
            originalColumnName = column.originalColumnName;
          }
        }
        
        if (originalColumnName) {
          backendSortingParams = {
            columnName: normalizeColumnName(originalColumnName),
            sortOrder: currentSortingParams.sortOrder
          };
          console.log('📦 [LOCAL] Sending to backend:', backendSortingParams);
        }
      }
      
      const response = await getData(
        currentPeriod,
        previousPeriod,
        campaignId,
        token,
        view,
        currentPage,
        search,
        backendSortingParams
      );

      setTimeout(() => {
        if (response?.success) {
          const transformedData = convertRowsToCamelCaseArray(response.data);
          
          // Build mapping between camelCase fields and original column names
          fieldToColumnMap = {};
          
          const columns = response.data.columns.map((column) => {
            const tooltipColumns = ["Top CPC", "Revenue"];
            const fieldName = toCamelCase(column);
            
            // Store the mapping
            fieldToColumnMap[fieldName] = column;

            return {
              headerName: getTableHeaders(column, language),
              field: fieldName,
              sortable: true,
              width: colWidth[fieldName],
              minWidth: colWidth[fieldName],
              hide: hiddenColumns.includes(column),
              // Store original column name for sorting
              colId: fieldName,
              originalColumnName: column,
              ...(tooltipColumns.includes(column) && {
                tooltipValueGetter: (params) => {
                  const usd = parseFloat(
                    String(params.value).replace(/[$,]/g, "").trim()
                  );
                  const rate = getCachedEurUsdRateSync();
                  if (isNaN(usd) || !rate || usd === 0) return null;
                  const eur = Math.round(usd * rate);
                  return `€${eur.toFixed(2)}`;
                },
              }),
            };
          });

          if (columns) {
            setColumns(columns);
          }

          params.success({
            rowData: transformedData,
            rowCount: response?.total || response?.data?.rows?.length || 0,
          });
        } else {
          params.fail();
        }
      }, 200);
    },
  };
}

